<div class="relative block w-full h-full rounded-md">
  <mat-label
    #labelElement
    class="mdc-floating-label mat-mdc-floating-label mdc-floating-label--float-above !top-[-0.45rem] z-10 ml-5"
    [style]="'transform: translateY(0) scale(0.75) !important'"
  >
    {{ label() | siaTranslate }}
  </mat-label>

  <div
    class="absolute left-1 top-0 h-[1px] w-[.7rem] border-t border-solid"
  ></div>
  <div
    class="absolute right-1 top-0 h-[1px] border-t border-solid"
    [style.left]="labelWidth + 12 + 'px'"
  ></div>
  <div
    class="border-b border-l border-r border-solid rounded-md text-medium"
    [style]="'height:' + textAreaHeight() + 'px; overflow:hidden; display:flex; flex-direction:column; resize:vertical;'"
  >
    @if (!isDisabled()) {
      <ngx-editor-menu
        [editor]="editor"
        [toolbar]="toolbar"
        [disabled]="isDisabled()"
        (click)="allowUpdate()"
      >
      </ngx-editor-menu>
    }
    <div (paste)="onPaste($event)" (mouseup)="allowUpdate()" style="flex-grow: 1; overflow: hidden; display: flex; flex-direction: column;">
    <ngx-editor
      [editor]="editor"
      [ngModel]="editorValue()"
      (ngModelChange)="onEditorValueChange($event)"
      [disabled]="isDisabled()"
      outputFormat="html"
      placeholder="Scrivi qui..."
      [class]="
        'forIOS transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]'
      "
      style="flex-grow: 1; resize: vertical; overflow: auto;"
      (keydown)="keyDownEvent()"
    >
    </ngx-editor>
    </div>
  </div>
  @if (showBottomMargin()) {
    <mat-hint
      sia-error-hint
      [statusMessage]="statusMessage()"
      [statusMessages]="statusMessages()"
    ></mat-hint>
  }
</div>
@if (environmentService.aiEnabled) {
  <sia-ai-text-button
    [text]="value()"
    (textChange)="value.set($event)"
    [category]="'crud-html-box'"
    [style]="showBottomMargin() ? 'margin-bottom: 16px' : ''"
    [disabled]="isDisabled()"
  ></sia-ai-text-button>
}
